import { CTABand } from "../../components/site/CTABand";
import { Link, useParams } from "react-router-dom";
import { SiteHeader } from "../../components/site/SiteHeader";
import { SiteFooter } from "../../components/site/SiteFooter";
import { PageHero } from "../../components/site/PageHero";
import { Reveal } from "../../components/motion/Reveal";
import { LEGAL_PAGES, LEGAL_ORDER } from "../../data/legal";
import NotFound from "./NotFound";

export default function Legal() {
  const { slug } = useParams();
  const page = LEGAL_PAGES[slug];
  if (!page) return <NotFound />;

  return (
    <div className="font-publicsans bg-nx-navy text-slate-200 antialiased" data-testid={`legal-${slug}`}>
      <SiteHeader />
      <PageHero crumb={page.crumb} eyebrow="Legal" title={page.title} />
      <section className="py-16 sm:py-24">
        <div className="nx-wrap grid lg:grid-cols-[1fr_1.8fr] gap-14">
          <div className="flex flex-col gap-2 lg:sticky lg:top-28 self-start">
            {LEGAL_ORDER.map((s) => (
              <Link key={s} to={`/legal/${s}`} className={`text-sm px-5 py-3 border transition-colors ${s === slug ? "border-nx-gold/50 text-nx-goldlight bg-nx-gold/[0.05]" : "border-white/10 text-slate-400 hover:text-white"}`} data-testid={`legal-nav-${s}`}>
                {LEGAL_PAGES[s].title}
              </Link>
            ))}
          </div>
          <div>
            {page.sections.map((s, i) => (
              <Reveal key={i} className="mb-12">
                <h2 className="font-marcellus text-2xl sm:text-3xl text-white mb-5" data-testid={`legal-section-${i}`}>{s.h}</h2>
                {s.p.map((p, j) => <p key={j} className="text-base text-slate-400 leading-relaxed mb-4">{p}</p>)}
              </Reveal>
            ))}
            <p className="text-xs text-slate-600 border-t border-white/10 pt-8">Last updated: August 2026. These pages are being prepared for qualified legal review before final publication.</p>
          </div>
        </div>
      </section>
      <CTABand />
      <SiteFooter />
    </div>
  );
}
